import { ApplicationState } from 'store'
import { PackageType } from 'modules/parcels/services/TrackingService/types'

export const getPackageTypes = (state: ApplicationState): PackageType[] => [...state.parcel.types]
